import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { Box } from "@mui/material";
import moment from "moment";

const CustomDateRangePicker = ({
  value = [null, null],
  onChange,
  isLock = false,
  isReadOnly = false,
  error,
  helperText,
  name = "",
  label = "Select Date Range",
}) => {
  return (
    <Box width="100%">
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DateRangePicker
          fullWidth
          disabled={isLock}
          readOnly={isReadOnly}
          value={[
            value[0] && moment(value[0]).isValid() ? moment(value[0]) : null,
            value[1] && moment(value[1]).isValid() ? moment(value[1]) : null,
          ]}
          onChange={(newValue) => {
            const [start, end] = newValue;
            if (moment(start).isValid() && moment(end).isValid()) {
              onChange?.([
                start && moment(start).isValid()
                  ? start.format("YYYY-MM-DD")
                  : null,
                end && moment(end).isValid() ? end.format("YYYY-MM-DD") : null,
              ]);
            } else {
              onChange?.([null, null]);
            }
          }}
          localeText={{ start: "Start Date", end: "End Date" }}
          slotProps={{
            textField: ({ position }) => ({
              fullWidth: true,
              name: `${name}_${position}`,
              label: position === "start" ? `${label} - From` : `${label} - To`,
              InputLabelProps: { shrink: true },
              InputProps: {
                readOnly: isReadOnly,
              },
              error,
              helperText,
            }),
          }}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default CustomDateRangePicker;
